import { registerMessages } from "../../../i18n/runtime";
import { countEn } from "./messages.en";
registerMessages("en", countEn);
registerMessages("es", { "pos.count.title": "Recuentos de existencias" });
